export default __webpack_public_path__ + "8104233ffd23805e3c7057a768931db5.png";